import React from "react";
import { useObserver } from "mobx-react-lite";
import { TextField, Grid } from "@material-ui/core";
import { AsyncButton } from "components";
import { useAccountFormStore } from "stores/AccountFormStore";

export default () => {
  const accountFormStore = useAccountFormStore();

  const handleCurrentPassword = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      accountFormStore.value.currentPassword = e.target.value;
    },
    [accountFormStore]
  );

  const handlePassword = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      accountFormStore.value.password = e.target.value;
    },
    [accountFormStore]
  );

  const save = React.useCallback(async () => {
    if (await accountFormStore.save()) {
      accountFormStore.modal(false);
    }
  }, [accountFormStore]);

  return useObserver(() => (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="現在のパスワード"
          type="password"
          value={accountFormStore.value.currentPassword || ""}
          error={!!accountFormStore.errors.columns.currentPassword}
          helperText={accountFormStore.errors.columns.currentPassword}
          onChange={handleCurrentPassword}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          label="新しいパスワード"
          type="password"
          value={accountFormStore.value.password || ""}
          error={!!accountFormStore.errors.columns.password}
          helperText={accountFormStore.errors.columns.password}
          onChange={handlePassword}
        />
      </Grid>

      <Grid item xs={12}>
        <AsyncButton onAwait={save}>保存</AsyncButton>
      </Grid>
    </Grid>
  ));
};
